import { $axios } from '@/modules/http/axios'

const vehiclesModule = {
  namespaced: true,

  state: () => ({
    vehicles: []
  }),

  getters: {
    getVehicles (state) {
      return state.vehicles
    }
  },

  mutations: {
    setVehicles (state, vehicles) {
      state.vehicles = vehicles
    }
  },

  actions: {
    async fetchVehicles ({ commit }) {
      const vehicles = (await $axios.get('Vehicle')).data
      commit('setVehicles', vehicles)
    }
  }
}

export default vehiclesModule
